import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const Home = () => {
  return <div className="w-full" data-id="element-245">
      {/* Hero Section */}
      <section className="bg-blue-600 text-white py-20" data-id="element-246">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
          <div className="text-center" data-id="element-248">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-249">
              Tu Nueva Vida: Redescubre el Retiro
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8" data-id="element-250">
              Un juego de mesa transformador para diseñar tu mejor forma de
              vivir el retiro
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-251">
              <Link to="/registro" className="bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-medium flex items-center justify-center" data-id="element-252">
                Registrarse <ArrowRightIcon size={20} className="ml-2" data-id="element-253" />
              </Link>
              <Link to="/juego" className="bg-blue-700 text-white hover:bg-blue-800 px-6 py-3 rounded-lg font-medium" data-id="element-254">
                Probar el juego
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Game Description */}
      <section className="py-16 bg-white" data-id="element-255">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
          <div className="text-center mb-12" data-id="element-257">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-258">
              ¿Qué es "Tu Nueva Vida"?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-259">
              Una herramienta educativa, inspiradora y profundamente personal
              para planificar tu retiro
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-260">
            <div data-id="element-261">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-262">
                Objetivo del juego
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-263">
                Guiar a cada jugador a través de un viaje de descubrimiento
                personal para diseñar su mejor forma de vivir el retiro,
                explorando aspectos clave como propósito, comunidad, salud,
                finanzas y legado.
              </p>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-264">
                Para quién es
              </h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-265">
                <li data-id="element-266">
                  Personas de 45+ años interesadas en planear su retiro con
                  intención
                </li>
                <li data-id="element-267">
                  Cualquier persona que quiera reflexionar sobre su futuro
                </li>
                <li data-id="element-268">
                  Hijos que desean apoyar a sus padres en su transición hacia el
                  retiro
                </li>
                <li data-id="element-269">
                  Grupos y comunidades interesados en reimaginar esta etapa de
                  la vida
                </li>
              </ul>
            </div>
            <div className="bg-blue-50 p-8 rounded-xl" data-id="element-270">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-271">
                Componentes del juego
              </h3>
              <ul className="space-y-4" data-id="element-272">
                <li className="flex items-start" data-id="element-273">
                  <span className="bg-blue-100 text-blue-600 p-2 rounded-full mr-3" data-id="element-274">
                    🧩
                  </span>
                  <div data-id="element-275">
                    <span className="font-medium" data-id="element-276">Tablero circular</span>
                    <p className="text-gray-700" data-id="element-277">
                      Representa el ciclo de vida hacia el retiro
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-278">
                  <span className="bg-blue-100 text-blue-600 p-2 rounded-full mr-3" data-id="element-279">
                    🧩
                  </span>
                  <div data-id="element-280">
                    <span className="font-medium" data-id="element-281">Cartas de 5 categorías</span>
                    <p className="text-gray-700" data-id="element-282">
                      Mentalidad, Vivienda, Finanzas, Salud y Conexión
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-283">
                  <span className="bg-blue-100 text-blue-600 p-2 rounded-full mr-3" data-id="element-284">
                    🧩
                  </span>
                  <div data-id="element-285">
                    <span className="font-medium" data-id="element-286">
                      Fichas y hojas de trabajo
                    </span>
                    <p className="text-gray-700" data-id="element-287">
                      Para registrar decisiones y crear tu plan de vida
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* How to Play */}
      <section className="py-16 bg-gray-50" data-id="element-288">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
          <div className="text-center mb-12" data-id="element-290">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-291">
              Cómo se juega
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-292">
              Un viaje en 4 fases para descubrir tu mejor forma de vivir el
              retiro
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-293">
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-294">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-295">
                1
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-296">
                El punto de partida
              </h3>
              <p className="text-gray-700" data-id="element-297">
                Cada jugador responde a preguntas sobre su visión actual del
                retiro y lo que le gustaría lograr en esa etapa.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-298">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-299">
                2
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-300">El Viaje</h3>
              <p className="text-gray-700" data-id="element-301">
                Avanza por el tablero, toma cartas de diferentes categorías y
                reflexiona sobre los retos que presentan.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-302">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-303">
                3
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-304">
                Las Decisiones Clave
              </h3>
              <p className="text-gray-700" data-id="element-305">
                Enfrenta decisiones importantes sobre vivienda, inversiones,
                tiempo y legado que definirán tu plan de retiro.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-306">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-307">
                4
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-308">El Plan de Vida</h3>
              <p className="text-gray-700" data-id="element-309">
                Crea tu "Manifiesto de Retiro" definiendo tus valores, forma
                ideal de vivir y propósito para esta etapa.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-310">
            <Link to="/manual" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium" data-id="element-311">
              Ver el manual completo{' '}
              <ArrowRightIcon size={20} className="ml-2" data-id="element-312" />
            </Link>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-blue-600 text-white" data-id="element-313">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-314">
          <h2 className="text-3xl font-bold mb-6" data-id="element-315">
            ¿Listo para redescubrir tu retiro?
          </h2>
          <p className="text-xl max-w-2xl mx-auto mb-8" data-id="element-316">
            Únete a nuestra comunidad y comienza a diseñar la mejor versión de
            tu futuro.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-317">
            <Link to="/registro" className="bg-white text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-medium" data-id="element-318">
              Registrarse ahora
            </Link>
            <Link to="/comunidad" className="bg-blue-700 text-white hover:bg-blue-800 px-6 py-3 rounded-lg font-medium" data-id="element-319">
              Explorar la comunidad
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;